import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Palette } from "lucide-react";

const backgroundColors = [
  { name: "Default", value: "bg-background", color: "bg-gray-100" },
  { name: "Blue", value: "bg-blue-50", color: "bg-blue-500" },
  { name: "Green", value: "bg-green-50", color: "bg-green-500" },
  { name: "Purple", value: "bg-purple-50", color: "bg-purple-500" },
  { name: "Orange", value: "bg-orange-50", color: "bg-orange-500" },
  { name: "Pink", value: "bg-pink-50", color: "bg-pink-500" },
  { name: "Cyan", value: "bg-cyan-50", color: "bg-cyan-500" },
  { name: "Red", value: "bg-red-50", color: "bg-red-500" },
];

interface BackgroundColorPickerProps {
  onColorChange: (color: string) => void;
  currentColor: string;
}

export function BackgroundColorPicker({ onColorChange, currentColor }: BackgroundColorPickerProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="sm" className="animate-fade-in">
          <div className="flex items-center gap-1">
            <Palette className="h-3 w-3 sm:h-4 sm:w-4" />
            <div 
              className={`w-2 h-2 sm:w-3 sm:h-3 rounded-full ${
                backgroundColors.find(bg => bg.value === currentColor)?.color || "bg-gray-100"
              }`} 
            />
          </div>
          <span className="sr-only">Change background color</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {backgroundColors.map(({ name, value, color }) => (
          <DropdownMenuItem
            key={value}
            onClick={() => onColorChange(value)}
            className={`flex items-center gap-2 ${currentColor === value ? "bg-accent" : ""}`}
          >
            <div className={`w-4 h-4 rounded-full ${color} border border-border`} />
            {name}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}